import classNames from 'classnames'
import React from 'react'
import ReactDOM from 'react-dom'
import { createUseStyles } from 'react-jss'
import { PopupStyles } from './Popup.styles'
import { IPopup } from './Popup.types'

const styles = createUseStyles(PopupStyles)

export const Popup: React.FC<IPopup> = ({ children, noPadding = false }) => {
  const classes = styles()
  const PopupContainer = (
    <>
      <div className={classes.overlay}></div>
      <div
        className={classNames({
          [classes.main]: true,
          [classes.noPadding]: noPadding
        })}
      >
        {children}
      </div>
    </>
  )
  if (typeof document !== 'undefined') {
    const modalElement = document.getElementById('app-modal')
    if (modalElement) {
      return ReactDOM.createPortal(PopupContainer, modalElement)
    }
  }
  return null
}
